import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import AdminClient from "../../AdminClient";
import utils from "../../utils";
import useFormValidation from "../../hooks/parsleyValidation";
import BasicSelect from "../basic/BasicSelect";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Box,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";

import AlertMessage from "../NavigationAndLayouts/AlertMessage";
import { useAlert } from "../../hooks/Alert";
import MixIcon from "../basic/MixIcon";
import { CKEditor } from 'ckeditor4-react';
import { isEqual } from "lodash";
import CurrencyBasic from "../basic/CurrencyBasic";

const Operations = (props) => {
  const agentInfo = props.agentInfo;
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();
  const companyConfBO = utils.getCurrentCompany().config.backoffice;
  const showDescription =
    companyConfBO?.operationDescription !== undefined &&
      !companyConfBO?.operationDescription
      ? true
      : false;
  const { t } = props;

  const [selected, alertOpen, showAlert, closeAlert] = useAlert();

  const { formValidation: formValidationActivity } = useFormValidation(
    "Form_AgentsActivity"
  );

  const userCanRetrieve = (actionType) => {
    if (
      companyConfBO.agents?.useParentBlocked &&
      actionType === "RETRIEVE" &&
      props.agentInfo.status === "DISABLED" &&
      props.agentInfo.blocked_by != undefined &&
      props.agentInfo.blocked_by !== null &&
      JSON.parse(utils.getSessionItem("user")).user !==
      props.agentInfo.blocked_by
    ) {
      adminClient
        .isParentFromUser(session, company, props.agentInfo.blocked_by)
        .then(
          (result) => {
            setCanRetrieve(true);
          },
          (err) => {
            setCanRetrieve(false);
          }
        );
    } else setCanRetrieve(true);
  };

  const optionsOperationsTokens = useMemo(() => {
    let options = [];
    if (utils.isGranted("SEND_TOKENS"))
      options.push({
        type: "SEND",
        name:
          t("ACTION_SEND") +
          " " +
          t("To value") +
          " " +
          " (" +
          agentInfo.alias +
          ")",
      });
    if (utils.isGranted("RETRIEVE_TOKENS"))
      options.push({
        type: "RETRIEVE",
        name:
          t("ACTION_RETRIEVE") +
          " " +
          t("From value") +
          " " +
          " (" +
          agentInfo.alias +
          ")",
      });
    return options;
  }, [agentInfo]);

  const [creditInfo, setCreditInfo] = useState({
    actionType: props.actionType || "SEND",
    // amount: 10.0,
    amount:1000,
    description: "",
  });

  const [canRetrieve, setCanRetrieve] = useState(false);

  useEffect(() => {
    userCanRetrieve(props.actionType || "SEND");
  }, []);

  const onChangeHandler = (e) => {
    const { name, value } = e.target || e;
    if (name !== undefined && value !== undefined) {
      setCreditInfo((prevState) => ({ ...prevState, [name]: value }));
      if (name === "actionType") {
        userCanRetrieve(value);
      }
    }
  };

  const save = (evt) => {
    if (formValidationActivity.validate()) {
      document.getElementById("operationAgent_btn").classList.add("hide");
      if (creditInfo.actionType === "SEND") {
        var promise = adminClient.sendTokens(
          session,
          agentInfo.user,
          company,
          //creditInfo.amount * 100,
          creditInfo.amount,
          agentInfo.currency,
          creditInfo.description
        );
        promise.then(
          function (response) {
            const channel = new BroadcastChannel("updateBalance");
            channel.postMessage("updateBalance");
            document
              .getElementById("operationAgent_btn")
              .classList.remove("hide");
            showAlert(t("Send tokens"), <p>{t("Tokens sent succesfully")}</p>, [
              <button
                type="button"
                className="btn btn-primary"
                onClick={(evt) => {
                  if (props.finishOperation)
                    props.finishOperation({
                      action: creditInfo.actionType,
                      type: "agent",
                      dataResponse: response.accounts,
                    });
                  if (props.showClose) props.showClose();
                  else closeAlert();
                }}
              >
                {t("Ok")}
              </button>,
            ]);
          },
          function (err) {
            console.error(err);
            document
              .getElementById("operationAgent_btn")
              .classList.remove("hide");
            showAlert(
              t("Send tokens"),
              <p>
                {t("Send tokens error") + ": " + t("ERROR_" + err.description)}
              </p>
            );
          }
        );
      } else {
        var promise = adminClient.retrieveTokens(
          session,
          agentInfo.user,
          company,
          // creditInfo.amount * 100,
          creditInfo.amount,
          agentInfo.currency,
          creditInfo.description
        );
        promise.then(
          function (response) {
            if (response.result === "OK") {
              const channel = new BroadcastChannel("updateBalance");
              channel.postMessage("updateBalance");
              document
                .getElementById("operationAgent_btn")
                .classList.remove("hide");
              showAlert(
                t("Retrieve tokens"),
                <p>{t("Tokens retrieved succesfully")}</p>,
                [
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(evt) => {
                      if (props.finishOperation)
                        props.finishOperation({
                          action: creditInfo.actionType,
                          type: "agent",
                          dataResponse: response.accounts,
                        });
                      if (props.showClose) props.showClose();
                      else closeAlert();
                    }}
                  >
                    {t("Ok")}
                  </button>,
                ]
              );
            } else {
              document
                .getElementById("operationAgent_btn")
                .classList.remove("hide");
              showAlert(
                t("Retrieve tokens"),
                <p>
                  {t("Send tokens error") + ": " + t("ERROR_" + response.code)}
                </p>
              );
            }
          },
          function (err) {
            console.error(err);
            document
              .getElementById("operationAgent_btn")
              .classList.remove("hide");
            showAlert(
              t("Retrieve tokens"),
              <p>
                {t("Send tokens error") + " " + t("ERROR_" + err.description)}
              </p>
            );
          }
        );
      }
    }
  };

  return (
    <>
      {!canRetrieve && (
        <p>El usuario esta bloqueado y no es por este usuario</p>
      )}
      <form id="Form_AgentsActivity">
        <div className="row">
          {props.showActionType && (
            <div
              className={props.showActionType ? "col-12 col-md-3" : "col-12"}
            >
              <BasicSelect
                idProperty="type"
                value={creditInfo.actionType}
                name="actionType"
                label={
                  "(" +
                  JSON.parse(utils.getSessionItem("user")).alias +
                  ") " +
                  t("I want to")
                }
                addOpts={optionsOperationsTokens}
                onChange={onChangeHandler}
                multiple={false}
                noEmptyValue={false}
                disableClearable={true}
              />
            </div>
          )}
          {canRetrieve && (
            <div
              className={props.showActionType ? "col-12 col-md-3" : "col-12"}
            >
              <CurrencyBasic
                      required
                      label={t("the amount")}
                      value={creditInfo.amount}
                      onChange={onChangeHandler}                       
                      decimalScale={2} 
                      fixedDecimalScale={true} 
                      allowNegative={false} 
                    />
              {/* <TextField
                label={t("the amount")}
                name="amount"
                type="number"
                InputProps={{
                  inputProps: {
                    step: "0.01",
                    "data-parsley-amount-greater": 0,
                  },
                }}
                value={creditInfo.amount}
                required
                onChange={onChangeHandler}
              /> */}
            </div>
          )}
          {canRetrieve && showDescription && (
            <div
              className={props.showActionType ? "col-12 col-md-6" : "col-12"}
            >
              <TextField
                label={t("Description")}
                name="description"
                type="text"
                value={creditInfo.description}
                onChange={onChangeHandler}
              />
            </div>
          )}
        </div>
      </form>
      <div className="row">
        <div className="col-12 ">
          {utils.isGranted("SEND_TOKENS") && canRetrieve && (
            <button
              id="operationAgent_btn"
              className="btn btn-primary"
              onClick={save}
            >
              {t("ACTION_" + creditInfo.actionType)}
            </button>
          )}
          {props.showClose && (
            <button className="btn btn-secondary" onClick={props.showClose}>
              {t("Close")}
            </button>
          )}
        </div>
      </div>
      <AlertMessage
        key={"SendAndRetrieve_alert"}
        isActive={alertOpen}
        size={selected.size}
        content={selected.content}
        title={selected.title}
        buttons={selected.buttons}
        handleCloseAlert={closeAlert}
      />
    </>
  );
};

const ChangePassword = (props) => {
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();
  const { t } = props;

  const { formValidation: formPassValidation } =
    useFormValidation("FormPassword");
  const [showPassword, setShowPassword] = useState({
    password: false,
    password2: false,
  });
  const [password, setPassword] = useState("");
  const [selected, alertOpen, showAlert, closeAlert] = useAlert();
  const minLength =
    utils.getCurrentCompany().config.backoffice?.minPassAdmin || 11;

  const handleClickShowPassword = (evt) => {
    const { name } = evt.currentTarget;
    setShowPassword((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const onChangePasswordHandler = (e) => {
    const { value } = e.target || e;
    setPassword(value);
  };

  const updatePassword = () => {
    if (formPassValidation.validate()) {
      adminClient
        .updateAgentPassword(session, company, props.agentUser, password)
        .then(
          function (data) {
            if (data.result === "OK") {
              showAlert(t("Agents"), t("Password updated succesfully"), [
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(evt) => {
                    if (props.showClose) props.showClose();
                    else closeAlert();
                  }}
                >
                  {t("Ok")}
                </button>,
              ]);
            } else
              showAlert(
                t("Agents"),
                t("Password updated error") + data.description
              );
          },
          function (err) {
            showAlert(
              t("Agents"),
              t("Password updated error") + err.description
            );
          }
        );
    }
  };

  return (
    <>
      <form id="FormPassword">
        <div className="row">
          <div className="col-12  col-md-6">
            <TextField
              label={t("New password")}
              type={showPassword.password ? "text" : "password"}
              name="password"
              onChange={onChangePasswordHandler}
              required
              inputProps={{
                "data-parsley-pattern": "^[a-zA-Z0-9]+$",
                "data-parsley-pattern-message": t(
                  "Password letters and numbers"
                ),
                minLength: minLength,
                id: "password",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onMouseDown={handleClickShowPassword}
                      onMouseUp={handleClickShowPassword}
                      edge="end"
                      name="password"
                    >
                      {showPassword.password ? (
                        <MixIcon mainIcon="eye-slash" />
                      ) : (
                        <MixIcon mainIcon="eye" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="col-12 col-md-6">
            <TextField
              label={t("Re password")}
              required
              type={showPassword.password2 ? "text" : "password"}
              inputProps={{
                "data-parsley-check-text-fields-equal": "[isEqual,password]",
                "data-parsley-check-text-fields-equal-message": t(
                  "New password different than re password"
                ),
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onMouseDown={handleClickShowPassword}
                      onMouseUp={handleClickShowPassword}
                      edge="end"
                      name="password2"
                    >
                      {showPassword.password2 ? (
                        <MixIcon mainIcon="eye-slash" />
                      ) : (
                        <MixIcon mainIcon="eye" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              name="pasword2"
              onChange={onChangePasswordHandler}
            />
          </div>
        </div>
      </form>
      <div className="row">
        <div className="col-12 ">
          {utils.isGranted("AGENTS_SAVE_AGENT") && (
            <button className="btn btn-primary" onClick={updatePassword}>
              {t("Update")}
            </button>
          )}
          {props.showClose && (
            <button className="btn btn-secondary" onClick={props.showClose}>
              {t("Close")}
            </button>
          )}
        </div>
      </div>
      <AlertMessage
        key={"Password_alert"}
        isActive={alertOpen}
        size={selected.size}
        content={selected.content}
        title={selected.title}
        buttons={selected.buttons}
        handleCloseAlert={closeAlert}
      />
    </>
  );
};
const SendNotification = (props) => {
  const [ckEditor, setCkEditor] = useState({ status: false, editor: undefined });
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();
  const { t } = props;

  const { formValidation: formPassValidation } =
    useFormValidation("FormNotification");
  const [notification, setNotification] = useState("");
  const [title, setTitle] = useState("");

  const [selected, alertOpen, showAlert, closeAlert] = useAlert();


  useEffect(() => {
    if (ckEditor.status) {
      let oldData = JSON.stringify(ckEditor.editor.getData())
      let newData = JSON.stringify("")

      if (!isEqual(oldData, newData)) {
        ckEditor.editor.setData("")
      }
    }

  }, [JSON.stringify(ckEditor.status)]);

  const handleEditorChange = (event) => {
    setCkEditor((prevState) => {
      if (prevState !== undefined) {
        const data = event.editor.getData();
        setNotification(data);
        return prevState
      }
    })
  };
  const onChangeHandlerNotification = (e) => {
    const { value } = e.target || e;
    setNotification(value);
  };
  const onChangeHandlerTitle = (e) => {
    const { value } = e.target || e;
    setTitle(value);
  };

  const sendNotification = (type) => {
    let agentsData = [];
    agentsData.push({ agent: props.agentUser.user, selectedType: type });

    if (formPassValidation.validate()) {
      adminClient
        .sendAgentNotification(
          session,
          company,
          JSON.stringify(agentsData),
          title,
          notification,
          type
        )
        .then(
          function (data) {
            if (data.result === "OK") {
              showAlert(t("Notifications"), t("Notification sent"), [
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(evt) => {
                    if (props.showClose) props.showClose();
                    else closeAlert();
                  }}
                >
                  {t("Ok")}
                </button>,
              ]);
            } else
              showAlert(
                t("Notifications"),
                t("Notification sent error") + data.description
              );
          },
          function (err) {
            showAlert(
              t("Notifications"),
              t("Notification sent error") + err.description
            );
          }
        );
    }
  };

  return (
    <>
      <form id="FormNotification">
        <div className="row">
          <div className="col-12">
            <TextField
              label={t("Title")}
              name="title"
              onChange={onChangeHandlerTitle}
            />
          </div>

          <div className="col-12">
            <CKEditor
              config={{ height: 200, allowedContent: true, versionCheck: false }}
              onChange={handleEditorChange}
              onInstanceReady={(evt) => {
                setCkEditor({ status: true, editor: evt.editor });
              }}
            />

          </div>
        </div>
      </form>
      <div className="row">
        <div className="col-12 ">
          {props.showClose && (
            <button className="btn btn-secondary" onClick={props.showClose}>
              {t("Close")}
            </button>
          )}
          {utils.isGranted("AGENTS_SEND_NOTIFICATION") && (
            <>
              <button
                className="btn btn-primary"
                onClick={() => {
                  sendNotification("node");
                }}
              >
                {t("Agent")}
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  sendNotification("children");
                }}
              >
                {t("SubAgents of")}
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  sendNotification("nodechildren");
                }}
              >
                {t("All")}
              </button>
            </>
          )}
        </div>
      </div>
      <AlertMessage
        key={"Notification_alert"}
        isActive={alertOpen}
        size={selected.size}
        content={selected.content}
        title={selected.title}
        buttons={selected.buttons}
        handleCloseAlert={closeAlert}
      />
    </>
  );
};

const ProviderPermissions = (props) => {
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();

  const { t } = props;

  const [selected, alertOpen, showAlert, closeAlert] = useAlert();
  const [providersUser, setProvidersUser] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [initCheckedItems, setInitCheckedItems] = useState({});

  const save = (evt) => {
    adminClient
      .saveAgentProvidersPermisions(
        session,
        company,
        props.agentUser,
        JSON.stringify(hasChangedPermissions())
      )
      .then(
        (response) => {
          if (response.result === "OK") {
            showAlert(t("Permissions"), t("Updating successful"));
            setInitCheckedItems(checkedItems);
          }
          console.log(JSON.stringify(response));
        },
        (error) => {
          props.showAlert(
            t("Permissions"),
            t("Updating error") + error.description
          );
        }
      );
  };

  useEffect(() => {
    //Consultamos los providers de la compañia del agente
    adminClient
      .getAgentProvidersPermisions(session, company, props.agentUser)
      .then(
        (result) => {
          //leemos los providers del agente
          //Marcamos como seleccionados aquellos que no tienen blocked y los que tienen blocked
          //Si esta bloqueado solo se mostrara el poderlo desbloquear aquellos que hayan sido bloqueados por mi o por uno de mis

          let providersAllowed = {};
          let providersList = [];
          for (let prov in result.data) {
            let providerData = result.data[prov];
            if (providerData.blocked_by === null) {
              providersAllowed[providerData.provider] = true;
              providersList.push(providerData);
            } else if (
              providerData.can_view === 1 &&
              providerData.can_modify === 1
            ) {
              providersAllowed[providerData.provider] = false;
              providersList.push(providerData);
            }
          }
          setCheckedItems(providersAllowed);
          setInitCheckedItems(providersAllowed);
          setProvidersUser(providersList);
        },
        (error) => { }
      );
  }, []);

  function hasChangedPermissions() {
    let changes = {};
    let hasChanged = false;

    for (let key in initCheckedItems) {
      if (initCheckedItems[key] !== checkedItems[key]) {
        changes[key] = checkedItems[key];
        hasChanged = true;
      }
    }
    return hasChanged ? changes : null;
  }

  // Maneja el cambio de cada checkbox
  const handleChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  // // Seleccionar/Deseleccionar todos
  const toggleAll = () => {
    const allChecked = Object.values(checkedItems).every(Boolean);
    const newCheckedState = providersUser.reduce((acc, item) => {
      acc[item.provider] = !allChecked;
      return acc;
    }, {});
    setCheckedItems(newCheckedState);
  };

  return (
    <>
      <form>
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Object.values(checkedItems).every(Boolean)}
                onChange={toggleAll}
              />
            }
            label={t("Select All")}
          />
        </Box>{" "}
        <FormGroup>
          {providersUser.map((provider, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  name={provider.provider}
                  checked={checkedItems[provider.provider] || false}
                  onChange={handleChange}
                />
              }
              label={provider.name}
            />
          ))}
        </FormGroup>
      </form>

      <Grid container spacing={1} justifyContent="right" mt={3}>
        {props.showClose && (
          <Grid item>
            <button className="btn btn-secondary" onClick={props.showClose}>
              {t("Close")}
            </button>
          </Grid>
        )}
        <Grid item>
          <button
            id="savePermissionAgent_btn"
            disabled={hasChangedPermissions() ? false : true}
            className="btn btn-primary"
            onClick={save}
          >
            {t("Save")}
          </button>
        </Grid>
      </Grid>

      <AlertMessage
        key={"PermissionAgents_alert"}
        isActive={alertOpen}
        size={selected.size}
        content={selected.content}
        title={selected.title}
        buttons={selected.buttons}
        handleCloseAlert={closeAlert}
      />
    </>
  );
};

const ToolBar = (props) => {
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();
  const companyConfBO = utils.getCurrentCompany().config.backoffice;
  const onlyHidden = props.onlyHidden;

  const { t } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goOperationTokens = (rowUser, actionType, title) => {
    props.showAlert(
      title,
      <SendAndRetrieve
        agentInfo={rowUser}
        finishOperation={props.finishOperation}
        actionType={actionType}
        showClose={props.handleCloseAlert}
      />,
      true
    );
  };

  const goDetails = (user) => {
    window.open("/agents/subagents/details/" + user, "_blank");
  };

  const goPassword = (rowUser) => {
    props.showAlert(
      t("Change Password"),
      <Password agentUser={rowUser} showClose={props.handleCloseAlert} />,
      true
    );
  };

  const sendNotification = (rowUser) => {
    props.showAlert(
      t("Notifications"),
      <Notification agentUser={rowUser} showClose={props.handleCloseAlert} />,
      true
    );
  };

  const showConfirmStatus = (rowUser, status) => {
    props.showAlert(
      t("Status"),
      <p>
        {t("Are you sure you want to change the status to ") +
          " " +
          t(status) +
          "?"}
      </p>,
      [
        <button
          type="button"
          className="btn btn-secondary"
          onClick={props.handleCloseAlert}
        >
          {t("Cancel")}
        </button>,
        <button
          type="button"
          className="btn btn-primary"
          onClick={(evt) => {
            props.handleCloseAlert();
            doChangeStatus(rowUser, status, true);
          }}
        >
          {t("All agents")}
        </button>,
        <button
          type="button"
          className={"btn btn-primary"}
          onClick={(evt) => {
            props.handleCloseAlert();
            doChangeStatus(rowUser, status, false);
          }}
        >
          {t("Only this agent")}
        </button>,
      ]
    );
  };

  const goStatus = async (row, status) => {
    if (
      companyConfBO.agents?.useParentBlocked &&
      row.blocked_by !== undefined &&
      row.blocked_by !== null &&
      JSON.parse(utils.getSessionItem("user")).user !== row.blocked_by
    ) {
      //Vemos el identificador de quien lo bloqueo, siempre que este habilitado en la company el control de bloqueo
      adminClient.isParentFromUser(session, company, row.blocked_by).then(
        (data) => {
          showConfirmStatus(row.user, status);
        },
        (err) => {
          props.showAlert(
            t("Status"),
            <p>{t("Agent blocked by other user")}</p>
          );
        }
      );
    } else showConfirmStatus(row.user, status);
  };
  const doChangeStatus = (rowUser, status, allAgents) => {
    adminClient
      .updateAgentStatus(session, company, rowUser, status, allAgents)
      .then(
        function (data) {
          if (data.result === "OK") {
            props.showAlert(t("Status"), t("Updating successful"), [
              <button
                type="button"
                className="btn btn-primary"
                onClick={(evt) => {
                  props.finishOperation({
                    action: "STATUS",
                    type: "agent",
                    dataResponse: {
                      status: status,
                      allAgents: allAgents,
                      useParentBlocked: companyConfBO.agents?.useParentBlocked,
                      agentsUpdated: data.data.trim(),
                    },
                  });
                  props.handleCloseAlert();
                }}
              >
                {t("Ok")}
              </button>,
            ]);
          } else
            props.showAlert(
              t("Status"),
              t("Updating error") + data.description
            );
        },
        function (err) {
          if (err.code === "blockedBy") {
            props.showAlert(
              t("Status"),
              t("Agent blocked by other user") + err.description,
              [
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(evt) => {
                    props.finishOperation({
                      action: "STATUS",
                      type: "agent",
                      dataResponse: {
                        status: status,
                        allAgents: allAgents,
                        useParentBlocked:
                          companyConfBO.agents?.useParentBlocked,
                        agentsUpdated: err.data,
                      },
                    });
                    props.handleCloseAlert();
                  }}
                >
                  {t("Close")}
                </button>,
              ]
            );
          } else
            props.showAlert(t("Status"), t("Updating error") + err.description);
        }
      );
  };

  const goVisibility = (row, action, type) => {
    props.showAlert(
      t(action),
      <p>
        {t("Are you sure you want to " + t(action)) + ": " + row.alias + " ?"}
      </p>,
      [
        <button
          type="button"
          className="btn btn-secondary"
          onClick={props.handleCloseAlert}
        >
          {t("Cancel")}
        </button>,
        <button
          type="button"
          className="btn btn-primary"
          onClick={(evt) => {
            props.handleCloseAlert();
            doChangeVisibility(row, action, type);
          }}
        >
          {t("Ok")}
        </button>,
      ]
    );
  };
  const doChangeVisibility = (user, action, type) => {
    let method = action.charAt(0).toLowerCase() + action.slice(1) + type;
    adminClient[method](session, company, user.user).then(
      function (data) {
        if (data.result === "OK") {
          props.showAlert(t(action), t("Updating successful"), [
            <button
              type="button"
              className="btn btn-primary"
              onClick={(evt) => {
                props.finishOperation({
                  action: "VISIBILITY",
                  type: "agent",
                  dataResponse: {
                    user: user,
                  },
                });
                props.handleCloseAlert();
              }}
            >
              {t("Ok")}
            </button>,
          ]);
        } else
          props.showAlert(t(action), t("Updating error") + data.description);
      },
      function (err) {
        props.showAlert(t(action), t("Updating error") + err.description);
      }
    );
  };

  const goPermission = (rowUser) => {
    props.showAlert(
      t("Permissions"),
      <Permissions agentUser={rowUser} showClose={props.handleCloseAlert} />,
      true,
      "xl"
    );
  };

  return (
    <>
      <div className="desktop-icons">
        {utils.isGranted("SEND_TOKENS") && onlyHidden === false && (
          <IconButton
            title={t("Send tokens")}
            className="icon-button"
            onClick={() =>
              goOperationTokens(props.row, "SEND", t("ACTION_SEND"))
            }
          >
            <MixIcon mainIcon="plus-circle" />
          </IconButton>
        )}
        {utils.isGranted("RETRIEVE_TOKENS") && onlyHidden === false && (
          <IconButton
            title={t("Retrieve tokens")}
            className="icon-button"
            onClick={() =>
              goOperationTokens(props.row, "RETRIEVE", t("ACTION_RETRIEVE"))
            }
          >
            <MixIcon mainIcon="minus-circle" />
          </IconButton>
        )}
        {utils.isGranted("AGENTS_SAVE_AGENT") && onlyHidden === false && (
          <>
            <IconButton
              title={
                props.row.status === "DISABLED"
                  ? t("Change to status") + " " + t("ENABLED")
                  : t("Change to status") + " " + t("DISABLED")
              }
              className="icon-button"
              onClick={() => {
                goStatus(
                  props.row,
                  props.row.status === "DISABLED" ? "ENABLED" : "DISABLED"
                );
                handleClose();
              }}
            >
              <MixIcon
                mainIcon={props.row.status === "DISABLED" ? "unlock" : "lock"}
              />
            </IconButton>

            <IconButton
              title={t("Change Password")}
              className="icon-button"
              onClick={() => goPassword(props.row.user)}
            >
              <MixIcon mainIcon="key" />
            </IconButton>
          </>
        )}
        {utils.isGranted("AGENTS_SAVE_GRANTS_PROVIDERS") &&
          onlyHidden === false && (
            <IconButton
              className="icon-button"
              title={t("Permissions")}
              onClick={() => goPermission(props.row.user)}
            >
              <MixIcon mainIcon={"user"} secondIcon={"cog"} iconbutton={true} />
            </IconButton>
          )}

        <IconButton
          title={props.row.hidden === 0 ? t("Hide") : t("Show")}
          className="icon-button"
          onClick={() => {
            props.row.hidden === 0
              ? goVisibility(props.row, "Hide", "Agent")
              : goVisibility(props.row, "Show", "Agent");
          }}
        >
          <MixIcon mainIcon={props.row.hidden === 0 ? "eye-slash" : "eye"} />
        </IconButton>

        {utils.isGranted("AGENTS_SEND_NOTIFICATION") &&
          onlyHidden === false && (
            <IconButton
              title={t("Notifications")}
              className="icon-button"
              onClick={() => sendNotification(props.row)}
            >
              <MixIcon mainIcon="comment" />
            </IconButton>
          )}

        <IconButton
          title={t("Details")}
          className="icon-button"
          onClick={() => goDetails(props.row.user)}
        >
          <MixIcon mainIcon="ellipsis-h" />
        </IconButton>
      </div>
      <div className="mobile-menu">
        {utils.isGranted("SEND_TOKENS") && onlyHidden === false && (
          <IconButton
            title={t("Send tokens")}
            className="icon-button"
            onClick={() =>
              goOperationTokens(props.row, "SEND", t("ACTION_SEND"))
            }
          >
            <MixIcon mainIcon="plus-circle" />
          </IconButton>
        )}
        {utils.isGranted("RETRIEVE_TOKENS") && onlyHidden === false && (
          <IconButton
            title={t("Retrieve tokens")}
            className="icon-button"
            onClick={() =>
              goOperationTokens(props.row, "RETRIEVE", t("ACTION_RETRIEVE"))
            }
          >
            <MixIcon mainIcon="minus-circle" />
          </IconButton>
        )}
        <IconButton onClick={handleClick} className="icon-button">
          <MixIcon mainIcon="bars" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {utils.isGranted("AGENTS_SAVE_AGENT") && onlyHidden === false && (
            <MenuItem
              onClick={() => {
                goStatus(
                  props.row,
                  props.row.status === "DISABLED" ? "ENABLED" : "DISABLED"
                );
                handleClose();
              }}
            >
              <MixIcon
                mainIcon={props.row.status === "DISABLED" ? "unlock" : "lock"}
                label={
                  props.row.status === "DISABLED"
                    ? t("Change to status") + " " + t("ENABLED")
                    : t("Change to status") + " " + t("DISABLED")
                }
              />
            </MenuItem>
          )}
          {utils.isGranted("AGENTS_SAVE_AGENT") && onlyHidden === false && (
            <MenuItem
              onClick={() => {
                goPassword(props.row.user);
                handleClose();
              }}
            >
              <MixIcon mainIcon="key" label={t("Change Password")} />
            </MenuItem>
          )}
          {utils.isGranted("AGENTS_SAVE_GRANTS_PROVIDERS") &&
            onlyHidden === false && (
              <MenuItem
                onClick={() => {
                  goPermission(props.row.user);
                  handleClose();
                }}
              >
                <MixIcon
                  className="icon-list-agents"
                  mainIcon="user"
                  secondIcon="cog"
                  label={t("Permissions")}
                />
              </MenuItem>
            )}
          <MenuItem
            onClick={() => {
              props.row.hidden === 0
                ? goVisibility(props.row, "Hide", "Agent")
                : goVisibility(props.row, "Show", "Agent");
              handleClose();
            }}
          >
            <MixIcon
              mainIcon={props.row.hidden === 0 ? "eye-slash" : "eye"}
              label={props.row.hidden === 0 ? t("Hide") : t("Show")}
            />
          </MenuItem>
          {utils.isGranted("AGENTS_SEND_NOTIFICATION") &&
            onlyHidden === false && (
              <MenuItem
                onClick={() => {
                  sendNotification(props.row);
                  handleClose();
                }}
              >
                <MixIcon
                  mainIcon="comment"
                  secondIncon="plus"
                  label={t("Notifications")}
                />
              </MenuItem>
            )}
          <MenuItem
            onClick={() => {
              goDetails(props.row.user);
              handleClose();
            }}
          >
            <MixIcon mainIcon="ellipsis-h" label={t("Details")} />
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};
const SendAndRetrieve = withTranslation()(Operations);
const Password = withTranslation()(ChangePassword);
const Permissions = withTranslation()(ProviderPermissions);
const Notification = withTranslation()(SendNotification);
const AgentToolBar = withTranslation()(ToolBar);
export { SendAndRetrieve, Password, AgentToolBar, Permissions };
